import { makeStyles } from 'tss-react/mui';

// Constants
import {
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_REGULAR,
  FONT_WEIGHT_SEMIBOLD,
} from '../../../constants/typography';

import { styleCondition } from '../../../utils/styleCondition';
import { pickIf } from '../../../utils/pickIf';

const getStackedContent = (isStacked) => {
  if (isStacked) {
    return {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    };
  }
  return {};
};

export const useStyles = makeStyles()(
  (
    theme,
    { customCardSize, isUnavailableForOrder, isKiteUser, isStacked } = {},
  ) => ({
    stackedContent: getStackedContent(isStacked),
    qtyColumn: { width: 195, alignSelf: 'flex-end' },
    root: {
      position: 'relative',
      borderRadius: 20,
      boxShadow: '0px 5px 15px rgba(44, 112, 172, 0.2)',
      display: 'flex',
      height: 275,
      [theme.breakpoints.down('lg')]: {
        height: 243,
      },
      [theme.breakpoints.down('md')]: {
        borderRadius: 10,
        height: 136,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          height: 243,
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          borderRadius: 10,
          height: 136,
        }),
      },
      ...customCardSize,
    },
    img: {
      ...(isUnavailableForOrder && {
        opacity: 0.65,
      }),
    },
    detailsBold: {
      fontWeight: pickIf(isKiteUser, FONT_WEIGHT_BOLD, FONT_WEIGHT_SEMIBOLD),
    },
    detailsNormal: {
      fontWeight: pickIf(isKiteUser, FONT_WEIGHT_REGULAR, FONT_WEIGHT_SEMIBOLD),
    },
    actionArea: {
      position: 'relative',
      width: 'initial',
    },
    descAndSize: {
      marginBottom: theme.spacing(1.5),
      [theme.breakpoints.down('lg')]: {
        marginBottom: 0,
      },
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(0.5),
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          marginBottom: 0,
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          marginBottom: theme.spacing(0.5),
        }),
      },
    },
    description: {
      cursor: 'pointer',
      display: '-webkit-box',
      fontSize: 18,
      fontWeight: 700,
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      wordBreak: 'break-word',
      [theme.breakpoints.down('lg')]: {
        fontSize: 14,
      },
      [theme.breakpoints.down('md')]: {
        fontSize: 12,
        WebkitLineClamp: 1,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: 14,
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: 12,
          WebkitLineClamp: 1,
        }),
      },
    },
    sizeVers: {
      [theme.breakpoints.down('sm')]: {
        fontSize: 10,
      },
      [theme.breakpoints.downLandscape('sm')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: 10,
        }),
      },
    },
    content: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      padding: '30px 16px 30px 30px !important',
      width: '100%',
      minWidth: 150,
      [theme.breakpoints.down('lg')]: {
        gap: theme.spacing(1),
        padding: '16px 16px 16px 20px !important',
      },
      [theme.breakpoints.down('md')]: {
        padding: '8px 10px !important',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          gap: theme.spacing(1),
          padding: '16px 16px 16px 20px !important',
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          padding: '8px 10px !important',
        }),
      },
    },
    details: {
      color: theme.palette.darkGrey,
      display: 'flex',
      gap: theme.spacing(8),
      fontSize: 14,
      fontWeight: 600,
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
        gap: 3,
        '& div:nth-child(2)': {
          order: 2,
        },
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          flexDirection: 'column',
          gap: 3,
          '& div:nth-child(2)': {
            order: 2,
          },
        }),
      },
    },
    detailsItem: {
      '& > span:first-child': {
        display: 'block',
        [theme.breakpoints.down('lg')]: {
          paddingRight: theme.spacing(0.5),
          display: 'initial',
        },
        [theme.breakpoints.downLandscape('lg')]: {
          ...styleCondition(theme.isMobileDevice, {
            paddingRight: theme.spacing(0.5),
            display: 'initial',
          }),
        },
      },
    },
    flagButton: {
      marginLeft: theme.spacing(2),
    },
    buttonsContainer: {
      display: 'flex',
      [theme.breakpoints.down('md')]: {
        width: 144,
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          width: 144,
        }),
      },
    },
    qtyButtons: {
      marginRight: theme.spacing(3),
      [theme.breakpoints.down('lg')]: {
        marginRight: 0,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          marginRight: 0,
        }),
      },
    },
    fdmButton: {
      alignSelf: 'end',
      fontSize: 12,
      marginLeft: 'auto',
      padding: theme.spacing(1),
      width: 105,
      [theme.breakpoints.down('lg')]: {
        alignSelf: 'start',
        marginLeft: 'initial',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          alignSelf: 'start',
          marginLeft: 'initial',
        }),
      },
    },
    ratingContainer: {
      [theme.breakpoints.down('lg')]: {
        marginBottom: theme.spacing(2),
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          marginBottom: theme.spacing(2),
        }),
      },
    },
    labels: {
      display: 'flex',
      columnGap: theme.spacing(1),
      position: 'absolute',
      left: theme.spacing(2),
      top: theme.spacing(2),
      zIndex: 10,
      [theme.breakpoints.down('md')]: {
        columnGap: theme.spacing(0.75),
        left: theme.spacing(1.25),
        top: theme.spacing(1.25),
      },
    },
  }),
);
